import config from '../package.json';
const ID = `${config.name}/actions/customerResetUserName`;
const createActionName = (name: string) => `app/${ID}/${name}`;

export const VERIFY_CURRENT_PASSWORD = createActionName(
  'VERIFY_CURRENT_PASSWORD',
);

export const UPDATE_VERIFY_CURRENT_PASSWORD_LOADING = createActionName(
  'UPDATE_VERIFY_CURRENT_PASSWORD_LOADING',
);

export const verifyCurrentPassword = (
  password: string,
  successfulCallback: () => void,
  failedCallback: (errCode: string) => void,
) => ({
  type: VERIFY_CURRENT_PASSWORD,
  payload: {
    password,
    successfulCallback,
    failedCallback,
  },
});

export const updateVerifyCurrentPasswordLoading = (loading: boolean) => ({
  type: UPDATE_VERIFY_CURRENT_PASSWORD_LOADING,
  isVerifyCurrentPasswordLoading: loading,
});
